import R from 'ramda'

const KEYWORD_TRIGGER_TYPE = 'KEYWORD'
const KEYWORD_DISPLAY_TYPE = 'Match keyword'

const isKeywordWidgetTrigger = R.propEq('type', KEYWORD_TRIGGER_TYPE)

const convertKeywordWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(KEYWORD_DISPLAY_TYPE),
  value: R.prop('data')
})

export { isKeywordWidgetTrigger, convertKeywordWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/keyword.js